export enum UserPermissionActionNameEnum {
  SEND_INVITATION = 'SEND_INVITATION',
}
